import { fetchBrokerageData } from "../../services/backendAPI";

export const FETCH_BROKERAGE_REQUEST = 'FETCH_BROKERAGE_REQUEST';
export const FETCH_BROKERAGE_SUCCESS = 'FETCH_BROKERAGE_SUCCESS';
export const FETCH_BROKERAGE_FAILURE = 'FETCH_BROKERAGE_FAILURE';
export const UPDATE_BROKERAGE_FROM_SOCKET = 'UPDATE_BROKERAGE_FROM_SOCKET';

export const fetchBrokerageAction = (forceRefresh = false) => async (dispatch, getState) => {
    const state = getState();
    const brokerageState = state.brokerage;

    if (brokerageState.loading) {
        return { status: 'loading', message: 'Already loading' };
    }
    
    if (!forceRefresh &&
        brokerageState.brokerageData &&
        Object.keys(brokerageState.brokerageData).length > 0) {
        return { status: 'success', data: brokerageState.brokerageData, cached: true };
    }

    dispatch({
        type: FETCH_BROKERAGE_REQUEST
    });

    try {
        const response = await fetchBrokerageData();

        if (response && response.data && Array.isArray(response.data.brokerage_rules)) {
            const grouped = {};
            response.data.brokerage_rules.forEach(rule => {
                if (rule.is_active) {
                    if (!grouped[rule.instrument_type]) {
                        grouped[rule.instrument_type] = [];
                    }
                    grouped[rule.instrument_type].push(rule);
                }
            });
            const brokerageData = {
                grouped,
                is_brokerage_applied: response.data.is_brokerage_applied,
                client_rules: response.data.client_rules
            };
            dispatch({
                type: FETCH_BROKERAGE_SUCCESS,
                payload: brokerageData
            });
            return { status: 'success', data: brokerageData };
        } else {
            dispatch({
                type: FETCH_BROKERAGE_FAILURE,
                payload: response.message || 'Failed to fetch brokerage data'
            });
            return { status: 'error', message: response.message };
        }
    } catch (error) {
        dispatch({
            type: FETCH_BROKERAGE_FAILURE,
            payload: error.message || 'Failed to fetch brokerage data'
        });
        return { status: 'error', message: error.message };
    }
};

// Action to clear brokerage error
export const clearBrokerageError = () => ({
    type: 'CLEAR_BROKERAGE_ERROR'
});

// Action to update brokerage from socket
export const updateBrokerageFromSocket = (socketData) => (dispatch) => {
    try {
        // Process the socket data - direct structure (not nested under data)
        if (socketData && Array.isArray(socketData.brokerage_rules)) {
            const grouped = {};
            socketData.brokerage_rules.forEach(rule => {
                if (rule.is_active) {
                    if (!grouped[rule.instrument_type]) {
                        grouped[rule.instrument_type] = [];
                    }
                    grouped[rule.instrument_type].push(rule);
                }
            });
            
            const brokerageData = {
                grouped,
                is_brokerage_applied: socketData.is_brokerage_applied,
                client_rules: socketData.client_rules,
                valid_till: socketData.valid_till,
                message: socketData.message // Include the message field
            };

            dispatch({
                type: UPDATE_BROKERAGE_FROM_SOCKET,
                payload: brokerageData
            });
        }
    } catch (error) {
        console.error('Error processing brokerage socket update:', error);
    }
}; 